import { loc } from '@okta/courage';
import { BaseForm } from '../../internals';
import BaseAuthenticatorView from '../../components/BaseAuthenticatorView';
import BackupCode from 'util/BackupCode';

const Body = BaseForm.extend({
  title() {
    return loc('oie.security.question.challenge.title', 'login');
  },

  // __BREX_CUSTOM__
  subtitle() {
    return loc('oie.security.question.challenge.description', 'login');
  },

  saveForm(model) {
    //remove any existing warnings or messages before saving form
    this.$el.find('.o-form-error-container').empty();
  
    // Convert answer to hash
    const authFrontendUrl = this.settings.get('authFrontendUrl') || '';
  
    BackupCode.verifyRecoveryCode(
      authFrontendUrl,
      this.options.model._previousAttributes['credentials.answer']
        || this.options.model.attributes['credentials.answer'],
      this.options.appState.attributes.user.id
    ).then(hash => {
      this.model.attributes['credentials.answer'] = hash;
      // Execute Captcha if enabled for this form.
      if (this.captchaObject) {
        this.captchaObject.execute();
      } else {
        this.options.appState.trigger('saveForm', model);
      }
    }).catch(() => {
      this.model.trigger('error', this.model, {
        responseJSON: { errorSummary: 'We could not validate the recovery code provided.' },
      });
    });
  },
  // __BREX_CUSTOM__

  save() {
    return loc('mfa.challenge.verify', 'login');
  },

  getUISchema() {
    const uiSchemas = BaseForm.prototype.getUISchema.apply(this, arguments);
    const questionKey = uiSchemas.filter(s => s.name.indexOf('questionKey') >= 0);
    const answer = uiSchemas.filter(s => s.name.indexOf('answer') >= 0);

    /**
     * At verify SQ case,
     * 'questionKey' is read-only hence it won't show up in UI anyway.
     * 'answer' has label 'answer' but apparently UI want to display the
     * actual question (label of `questionKey`) as better user experience.
     */
    if (questionKey.length === 1 && answer.length === 1) {
      answer[0].label = questionKey[0].label;
    }
    
    // __BREX__CUSTOM__
    answer[0].label = loc('oie.security.question.challenge.label', 'login');
    // __BREX__CUSTOM__

    return uiSchemas;
  }
});

export default BaseAuthenticatorView.extend({
  Body,
});
